/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from "react";
import { BackgroundProvider } from "./src/context/BackgroundContext";
import { setViewportHeight } from "./src/components/utils";

export const wrapRootElement = ({ element }) => (
  <BackgroundProvider>{element}</BackgroundProvider>
);

// Initialize viewport height custom property
export const onClientEntry = () => {
  // Call the function initially
  if (typeof window !== 'undefined') {
    // Run after the window object is available
    window.addEventListener('load', () => {
      setViewportHeight();
      // Add event listener for resize and orientation change
      window.addEventListener('resize', setViewportHeight);
      window.addEventListener('orientationchange', setViewportHeight);
    });
  }
};

require('./src/sass/base/_base.scss');
require('./src/sass/base/_typography.scss');
